import { isEmpty, get } from "lodash";
import EXTENSIONS from "@/constants/extensions";
import CubexService from "@/services/setting/cubex";

export default {
    data() {
        return {
            isCubex: false,
            showPendingCubexItemAlert: false,
            cubexBufferTime: null,
            pendingCubexRequestController: null,
        };
    },
    computed: {
        creditWarningMessage() {
            return `Applying credit for this invoice will apply a <strong>${this.cubexBufferTime} minutes</strong> buffer time to all pending CUBEX items. After this buffer period expires, pending items will be automatically cancelled if not dispensed.`;
        }
    },
    methods: {
        isCubexItem(item) {
            // console.log("isCubexItem", item);
            // First check if Cubex extension is enabled
            if (!this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CUBEX)) {
                return false;
            }

            // Handle empty/null cases
            if (isEmpty(item)) {
                return false;
            }

            if (
                item.record_resources?.form_data?.item_dispensing_reference &&
                item.record_resources?.form_data?.item_dispensing_reference
                    .length > 0
            ) {
                return true;
            }

            // Check all possible Cubex indicators
            return (
                // Case 1: Item has dispensing reference
                get(item, "item_dispensing_references.length") > 0 &&
                get(item, "item_dispensing_references[0].source") ===
                    EXTENSIONS.CODE.CODE_CUBEX ||
                // Case 2: Item has been synced with Cubex
                Boolean(item.cubex_last_sync)
            );
        },

        async getPendingCubexItem(invoiceIds) {
            if (!invoiceIds || invoiceIds.length === 0) {
                this.resetCubexAlert();
                return;
            }

            // Cancel any existing request
            if (this.pendingCubexRequestController) {
                this.pendingCubexRequestController.abort();
            }

            // Create new abort controller for this request
            this.pendingCubexRequestController = new AbortController();

            let alertFound = false;

            // Check each invoice ID sequentially, stop when any pending item is found
            for (const invoiceId of invoiceIds) {
                try {
                    const response = await CubexService.getPendingCubexItem(
                        invoiceId,
                        this.pendingCubexRequestController?.signal
                    );

                    if (response.resources.length > 0) {
                        let cubexCredentials = this.$store.getters[
                            "cubex/credentials"
                        ];

                        this.cubexBufferTime =
                            cubexCredentials?.buffer_time || 20;
                        this.showPendingCubexItemAlert = true;
                        alertFound = true;

                        break; // Exit loop - no need to check remaining invoices
                    }
                } catch (error) {
                    // Check if request was aborted
                    if (error.name === 'AbortError') {
                        console.log('Request was cancelled');
                        return; // Exit early if cancelled
                    }
                    
                    console.error(
                        `Error checking pending CUBEX items for invoice ${invoiceId}:`,
                        error
                    );
                }
            }

            // Only reset if we actually checked for items and found none
            if (!alertFound && invoiceIds.length > 0) {
                this.resetCubexAlert();
            }

            // Clear the controller after request completes
            this.pendingCubexRequestController = null;
        },

        resetCubexAlert() {
            this.showPendingCubexItemAlert = false;
            this.cubexBufferTime = null;
        }
    }
};
